import React, { useEffect } from "react";

const About = () => {
  useEffect(() => {
    document.title = "About Us - Senior Vault Capital"; // Updated title
  }, []);

  return (
    <div className="bg-[#ffffff] overflow-x-hidden">
      <section className="relative pt-40">
        {/* Decorative Image */}
        <div className="absolute inset-0 flex justify-center items-center z-0">
          <img
            src="https://cdn.prod.website-files.com/637b8553d2b3433e9297cdb4/63bfdb147093626ba9d65cfa_S.svg"
            alt="Decorative S"
            className="w-72 h-72 opacity-10"
            loading="lazy"
          />
        </div>

        {/* Heading */}
        <h1 className="text-xl md:text-4xl font-semibold text-center mb-6 relative z-10 text-[#000300]">
          Unlock Your Financial Potential with Senior Vault Capital
        </h1>

        {/* Tagline Paragraph */}
        <p className="text-[#000300] text-base md:text-lg leading-relaxed text-center mb-8 relative z-10 max-w-3xl mx-auto">
          At Senior Vault Capital, we're passionate about helping you achieve your financial goals. Our team of experts provides personalized guidance and support to help you navigate the complex world of finance.
        </p>

        {/* Our Story Section */}
        <div className="mt-12 relative z-10">
          <h2 className="text-2xl md:text-3xl font-semibold text-center mb-6 text-[#000300]">
            Our Story
          </h2>
          <p className="text-[#000300] text-base md:text-lg leading-relaxed text-center mb-8 max-w-3xl mx-auto">
            We're a leading financial services firm dedicated to delivering high-impact investment and advisory solutions. With years of experience and a deep understanding of global markets, we're committed to driving sustainable growth and prosperity for our clients.
          </p>
        </div>

        {/* Our Services Section */}
        <div className="mt-12 relative z-10">
          <h2 className="text-2xl md:text-3xl font-semibold text-center mb-6 text-[#000300]">
            How We Work
          </h2>
          <div className="lg:text-center md:text-center">
            <p className="text-[#000300] text-base md:text-lg leading-relaxed text-center mb-8 max-w-3xl mx-auto">
              We take a tailored approach to financial planning, offering:
            </p>
            <ul className="list-disc list-outside pl-5 text-[#000300] text-base md:text-lg leading-relaxed max-w-3xl mx-auto">
              <li className="mb-2">Personalized Investment Strategies: Customized plans designed to meet your unique financial objectives</li>
              <li className="mb-2">Risk Management: Data-driven solutions to protect your assets and minimize risk</li>
              <li className="mb-2">Global Market Expertise: Decades of experience navigating cross-border investments and opportunities</li>
              <li className="mb-2">Innovative Advisory Services: Future-focused guidance to help you build wealth and achieve your goals</li>
              <li>Legacy Planning: Expert advice on creating a lasting financial legacy for generations to come</li>
            </ul>
          </div>
        </div>

        {/* Our Values Section */}
        <div className="mt-12 relative z-10">
          <h2 className="text-2xl md:text-3xl font-semibold text-center mb-6 text-[#000300]">
            Why Partner With Us?
          </h2>
          <div className="lg:text-center md:text-center">
            <ul className="list-disc list-outside pl-5 text-[#000300] text-base md:text-lg leading-relaxed max-w-3xl mx-auto">
              <li className="mb-2">
                <strong>Client-Focused Approach:</strong> We prioritize your needs and goals above all else
              </li>
              <li className="mb-2">
                <strong>Market Expertise:</strong> Our team has deep insights and experience in navigating complex markets
              </li>
              <li className="mb-2">
                <strong>Transparent Communication:</strong> We keep you informed every step of the way
              </li>
              <li>
                <strong>Results-Oriented:</strong> We're committed to delivering tangible results and helping you achieve your financial aspirations
              </li>
            </ul>
          </div>
        </div>

        {/* Mission Section */}
        <div className="mt-12 relative z-10">
          <h2 className="text-2xl md:text-3xl font-semibold text-center mb-6 text-[#000300]">
            Our Purpose
          </h2>
          <p className="text-[#000300] text-base md:text-lg leading-relaxed text-center mb-8 max-w-3xl mx-auto">
            At Senior Vault Capital, our purpose is to empower individuals, businesses, and institutions to achieve their financial goals. We measure our success by the prosperity and financial well-being of our clients.
          </p>
        </div>

        {/* CTA Section */}
        <div className="mt-12 relative z-10">
          <p className="text-[#000300] text-base md:text-lg leading-relaxed text-center mb-8 max-w-3xl mx-auto">
            Ready to unlock your financial potential? Contact Senior Vault Capital today to schedule a consultation and start building a brighter financial future.
          </p>
        </div>

        {/* Separator */}
        <div className="w-full h-[2px] bg-gray-200 mt-8"></div>
      </section>
    </div>
  );
};

export default About;